var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ChinaMapTerimal"}},[_c('echartsChina',{ref:"echartChina",staticStyle:{"height":"100%"},attrs:{"data":_vm.ehartsChinaObjec}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }